import React, { Component } from 'react'
import {
  Layout,
  Form,
  Input,
  Button,
  Breadcrumb,
  Select,
  Upload,
  DatePicker,
  message,
  TimePicker,
  Spin,
  Checkbox,
  Switch,
} from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import './ImportSampleOrder.scss'
import HistoryTable from '../../components/HistoryTable/HistoryTable'
import { NavLink } from 'react-router-dom'
import { HTTPService } from '../../otherServices/apiService'
import moment from 'moment'
import {
  DATE_FORMAT,
  TIME_FORMAT,
  PERMISSIONS_BY_NAME,
  PAGE_LIMIT,
  USER_SORTING,
} from '../../otherServices/constant'
import { trimSpace, isPermission } from '../../otherServices/commonFunction'

const { Content } = Layout

const { Option } = Select

class ImportSampleOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formData: null,
      loader: false,
      file: null,
      toggle_s4r3: false,
      toggle_s4r4: false,
      isDistributionData: false,
      users: [],
    }
    this.getFormData = this.getFormData.bind(this)
    this.handleFinish = this.handleFinish.bind(this)
  }

  //function to fetch form data
  componentDidMount() {
    this.getFormData()
  }
  async getFormData() {
    this.setState({ loader: true })
    const data = { ftp_purpose: this.props.ftp_purpose }
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: `ftp-detail/?ftp_purpose=${this.props.ftp_purpose}`,
      })
      if (userRes.success) {
        let startDate = moment(userRes.data.start_date)
        let starTime = moment(userRes.data.start_time, TIME_FORMAT)
        userRes.data.start_date = startDate
        userRes.data.start_time = starTime
        this.setState({
          formData: userRes.data,
        })
        this.setState({
          toggle_s4r3: userRes.data.api_to_s4_r3,
        })
        this.setState({ toggle_s4r4: userRes.data.api_to_s4_r4 })
        this.setState({ loader: false })
      } else {
        message.error(userRes.message)
        this.setState({ loader: false })
      }
    } catch (error) {
      this.setState({ loader: false })
      message.error('Failed to Fetch')
    }
  }

  //function to submit form
  async handleFinish(values) {
    let valueData = trimSpace(values)
    let { manual_upload_file, ...otherData } = valueData
    this.setState({ loader: true })
    valueData.ftp_purpose = this.props.ftp_purpose
    let startDate = valueData.start_date
    let startTime = valueData.start_time
    valueData.start_date = moment(startDate).format(DATE_FORMAT)
    valueData.start_time = moment(startTime).format(TIME_FORMAT)
    valueData.dragger = ''
    valueData.ftp_url = valueData.ftp_url || ''
    valueData.manual_upload_file = this.state.file
    let formData = new FormData()
    for (let key in valueData) {
      formData.set(key, valueData[key])
    }
    try {
      let userRes = await HTTPService({
        method: 'POST',
        url: 'ftp-detail/save/',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      if (userRes.success) {
        this.getFormData()
        message.success('Form Submited Successfully')
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      message.error('Failed to Update', error)
    }
  }

  renderFields() {
    const ftp_purpose = this.props.ftp_purpose
    let archiveFolder
    let lableName2
    if (ftp_purpose === 'ConsignmentSampleIssueOrderS4') {
      archiveFolder = 'ftp_archive_folder'
      lableName2 = 'Consignment Sample Issue Order S4 Import Archive'
    }
    if (ftp_purpose === 'SampleOrderToS4') {
      archiveFolder = 'ftp_archive_folder'
      lableName2 = 'Sample Order S4 Import Archive'
    }
    if (ftp_purpose === 'send_success_logs') {
      archiveFolder = 'send_success_logs'
      lableName2 = 'Sample Order S4 Import Archive'
    }
    return (
      <div className="formitem_row">
        <Form.Item
          label={lableName2}
          name={archiveFolder}
          rules={[
            {
              required: true,
              message: `Please input your ${lableName2} !`,
            },
          ]}
        >
          <Input placeholder={lableName2} size="large" />
        </Form.Item>
      </div>
    )
  }

  async handleChanges({ file, onSuccess }) {
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
    this.setState({ file })
  }

  handleChange = (selectedItems) => {
    this.setState({ selectedItems })
  }

  onFinishFailed = (errors) => {
    message.error('Enter the required fields!')
  }

  renderForm() {
    const { selectedItems } = this.state
    const ftp_purpose = this.props.ftp_purpose
    const { users } = this.props
    return (
      <div className="ImportSampleOrderStyles">
        <div className="ImportSampleOrder_container">
          <div className="ImportSampleOrder__title">{this.props.tabTitle}</div>
          <div className="layout_content_box ImportSampleOrder_whitebox">
            <Form
              className="form_block_main import-sample-order-form"
              initialValues={this.state.formData}
              onFinish={this.handleFinish}
              onFinishFailed={this.onFinishFailed}
            >
              <div className="formitem_row">
                {this.renderFields()}
                <Form.Item
                  name="email_output_to"
                  label="Select distribution List"
                  rules={[
                    {
                      required: true,
                      message: 'Please Select Dstribution group/ Enter MailID!',
                    },
                  ]}
                >
                  <Select
                    className="multiple_select"
                    mode="tags"
                    placeholder="Select Dstribution group or Enter MailID"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={selectedItems}
                    onChange={this.handleChange}
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option && option.children
                        ? option.children.indexOf(input.toLowerCase()) >= 0
                        : null
                    }
                    tokenSeparators={[',']}
                  >
                    {users.length &&
                      users.map((item) => (
                        <Select.Option key={item.name} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="formitem_row">
                <Form.Item
                  label="Username"
                  name="ftp_username"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input placeholder="John Doe" size="large" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="ftp_password"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your email!',
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="********"
                    size="large"
                    type="password"
                  />
                </Form.Item>
              </div>
              <div className="formitem_row">
                <Form.Item name="ftp_url" label="URL">
                  <Input placeholder="Enter URL" type="text" />
                </Form.Item>
              </div>
              <div className="formitem_row">
                <Form.Item
                  name="api_to_s4_r3"
                  label="api to S4 R3"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={this.state.toggle_s4r4}
                    onChange={() =>
                      this.setState({ toggle_s4r3: !this.state.toggle_s4r3 })
                    }
                  >
                    api to S4 R3
                  </Switch>
                </Form.Item>
                <Form.Item
                  name="api_to_s4_r4"
                  label="api To S4 R4"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={this.state.toggle_s4r3}
                    onChange={() =>
                      this.setState({ toggle_s4r4: !this.state.toggle_s4r4 })
                    }
                  >
                    api To S4 R4
                  </Switch>
                </Form.Item>
                <Form.Item
                  name="send_success_logs"
                  label="Send logs for success"
                  valuePropName="Unchecked"
                  hidden={true}
                >
                  <Checkbox> Send logs for success</Checkbox>
                </Form.Item>
              </div>

              {isPermission(
                //check for save permission
                PERMISSIONS_BY_NAME['Manage FTP settings']
              ) && (
                <div className="formitem_action_row">
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      size="large"
                    >
                      Save
                    </Button>
                  </Form.Item>
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
    )
  }

  render() {
    // return this.state.loader ? (
    //   <div className="loader">
    //     <Spin />
    //   </div>
    // ) : this.state.formData ? (
    //   <div>{this.renderForm()}</div>
    // ) : <Spin />
    return this.state.loader ? (
      <div className="loader">
        <Spin />
      </div>
    ) : (
      <div>{this.renderForm()}</div>
    )
  }
}

export default ImportSampleOrder
